module.exports = __webpack_public_path__ + "img/NoImage.b9e45ee4.jpg";